import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcArrowrightFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    fill: "none",
    viewBox: "0 0 8 12",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .55C0 .09.539-.166.903.121l6.888 5.45a.546.546 0 0 1 0 .858l-6.888 5.45c-.364.287-.903.031-.903-.43z"
  }));
}
var IcArrowrightFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowrightFillNomargin));

export { IcArrowrightFillNomargin as I };
